/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function(){
  $('.announcement-container-on').slick({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
      pauseOnDotsHover: true,
      regionLabel: 'Announcement Bar Carousel',
      prevArrow: '<button type="button" class="slick-prev u-hidden-visually">Previous Banner Announcement Message</button>',
      nextArrow: '<button type="button" class="slick-next u-hidden-visually">Next Banner Announcement Message</button>',
      playIcon: '<span class="slick-play-icon" aria-hidden="true"><i class="play-icon"></i></span>',
      pauseIcon: '<span class="slick-pause-icon" aria-hidden="true"><i class="pause-icon"></i></span>'
  });
});